import React from 'react'

export const getStudentActivityColumns = ( handleDelete, isProfile = false, openEditModal) => {
	const columns = [
		{
			name: 'Order',
			selector: (row) => row.sortorder,
			sortable: true,
			width: '70px',
			minWidth: '70px',
			maxWidth: '80px'
		},
		{
			name: 'Title',
			selector: (row) => row.title,
			sortable: true,
			minWidth: '240px',
			maxWidth: '320px',
			grow: 2,
			wrap: false,
			cell: (row) => (
				<div className="text-truncate w-100 text-start" title={row.title || ''}>
					{row.title || '—'}
				</div>
			)
		},
		{
			name: 'Status',
			selector: (row) => row.status,
			sortable: true,
			width: '88px',
			minWidth: '80px',
			maxWidth: '96px',
			style: {
				justifyContent: 'flex-start',
				textAlign: 'left'
			},
			cell: (row) => (
				<div className="w-100 text-start" style={{ minWidth: 0 }}>
					{row.status || '—'}
				</div>
			)
		},
		{
			name: 'Position',
			selector: (row) => row.position,
			sortable: true,
			width: '96px',
			minWidth: '88px',
			maxWidth: '120px',
			wrap: true
		},
		{
			name: 'Tier',
			selector: (row) => row.recoglevel,
			sortable: true,
			minWidth: '104px',
			maxWidth: '130px',
			grow: 0,
			wrap: true,
			cell: (row) => <span className="d-inline-block text-break">{row.recoglevel || '—'}</span>
		},
		{
			name: 'Grade',
			selector: (row) => row.gradelevel,
			sortable: true,
			width: '120px',
			minWidth: '100px',
			maxWidth: '160px',
			wrap: true,
			cell: (row) => (
				<span className="d-inline-block text-break" title={row.gradelevel || ''}>
					{row.gradelevel || '—'}
				</span>
			)
		},
		{
			name: 'Week',
			selector: (row) => row.weeksperyear,
			sortable: true,
			width: '70px',
			minWidth: '70px',
			maxWidth: '80px'
		},
		{
			name: 'Hours',
			selector: (row) => row.hoursperweek,
			sortable: true,
			width: '70px',
			minWidth: '70px',
			maxWidth: '80px'
		},
		{
			name: 'Category',
			selector: (row) => row.category,
			sortable: true,
			minWidth: '100px',
			maxWidth: '132px',
			grow: 0.5,
			wrap: true
		}
	]

	// Add Actions column only if not in profile view
	if (!isProfile) {
		columns.push({
			name: 'Actions',
			selector: (row) => row.id,
			sortable: false,
			width: '118px',
			minWidth: '110px',
			maxWidth: '128px',
			cell: (row) => (
				<div className="d-flex gap-1 justify-content-start align-items-center flex-nowrap">
					<button type="button" onClick={() => openEditModal(row.id)} className="btn btn-success btn-sm" title="Edit">
						<i className="fa fa-edit me-1"></i>
					</button>
					<button type="button" className="btn btn-danger btn-sm" title="Delete" onClick={() => handleDelete(row.id)}>
						<i className="fa fa-trash"></i>
					</button>
				</div>
			),
			ignoreRowClick: true
		})
	}

	return columns
}
